import { render, staticRenderFns } from "./AnaliticalReferrals.vue?vue&type=template&id=919d12d6&scoped=true&"
import script from "./AnaliticalReferrals.vue?vue&type=script&lang=js&"
export * from "./AnaliticalReferrals.vue?vue&type=script&lang=js&"
import style0 from "./AnaliticalReferrals.vue?vue&type=style&index=0&id=919d12d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919d12d6",
  null
  
)

export default component.exports